import React, {Component} from 'react';
import PercentChart from './PercentChart';

export default class NIM extends Component {
  render() {
    return <PercentChart up title='NIM' upDownPercent='5.90%' percent='3.40%' />;
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/PercentChart/NIM.js